import { AutogenModelFuelPrice, AutogenRowFuelPrice } from "./autogen/AutogenModelFuelPrice";

export class ModelFuelPrice extends AutogenModelFuelPrice<RowFuelPrice> {
	constructor() {
		super(RowFuelPrice);
	}
}

export class RowFuelPrice extends AutogenRowFuelPrice {
}